// removed by extract-text-webpack-plugin
module.exports = {"not-found":"NotFound__not-found___1BwwT"};


//////////////////
// WEBPACK FOOTER
// ./src/views/NotFound/NotFound.css
// module id = 716
// module chunks = 0